import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Helmet} from 'react-helmet';
import {ClickAwayListener, Grid} from '@material-ui/core';
import MyOzgeneToolbar from 'navigation/components/MyOzgeneToolbar';
import MyOzgeneDrawer from 'navigation/components/MyOzgeneDrawer';
import AppContent from 'navigation/components/AppContent';

const drawerWidth = 240;
const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundImage:
      process.env.REACT_APP_SANDBOX === 'true' || !process.env.REACT_APP_BACKGROUND_IMAGE
        ? 'none'
        : `url("${process.env.REACT_APP_BACKGROUND_IMAGE}")`,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingRight: 0,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  title: {
    paddingLeft: theme.spacing(3),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100vh',
  },
  drawerIcon: {
    marginLeft: 5,
  },
  drawerMenuItem: {
    height: 48,
  },
});

function Navigation(props) {
  const {
    children,
    classes,
    onCloseDrawer,
    drawerOpen,
    dialogOpen,
    onOpenDialog,
    onCloseDialog,
    navTransitions,
    onLogout,
    user,
    onOpenDrawer,
  } = props;

  return (
    <div className={classes.root}>
      <Helmet titleTemplate={`%s | ${process.env.REACT_APP_APP_NAME} `} />

      <ClickAwayListener onClickAway={onCloseDrawer}>
        <Grid>
          <MyOzgeneToolbar onOpenDrawer={onOpenDrawer} drawerOpen={drawerOpen} classes={classes} />
          <MyOzgeneDrawer
            onCloseDrawer={onCloseDrawer}
            drawerOpen={drawerOpen}
            dialogOpen={dialogOpen}
            onOpenDialog={onOpenDialog}
            onCloseDialog={onCloseDialog}
            navTransitions={navTransitions}
            onLogout={onLogout}
            classes={classes}
            user={user}
          />
        </Grid>
      </ClickAwayListener>

      <AppContent classes={classes}>{children}</AppContent>
    </div>
  );
}

Navigation.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.object.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  navTransitions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onLogout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  onOpenDrawer: PropTypes.func.isRequired,
};

export default withStyles(styles)(Navigation);
